// Below md there is no room for the side rails next to the map, so the
// doctrine rail, the info rail (selection: city / unit / Champion panels)
// and the minimap become drawers, hidden by default and opened
// from these bottom-left toggles (one at a time, so they never overlap).

import { Button } from '@aod/ui/components/ui/button';
import { Info, Map as MapIcon, Sparkles } from 'lucide-react';
import { useT } from '../i18n/index.js';
import { appDom } from '../lib/appDom.js';

export type MobileHudPanel = 'none' | 'doctrine' | 'map' | 'info';

interface MobileHudTogglesProps {
  readonly active: MobileHudPanel;
  readonly onChange: (next: MobileHudPanel) => void;
}

export function MobileHudToggles({ active, onChange }: MobileHudTogglesProps) {
  const t = useT();
  const toggle = (panel: Exclude<MobileHudPanel, 'none'>) =>
    onChange(active === panel ? 'none' : panel);
  return (
    <div
      data-testid="mobile-hud-toggles"
      {...appDom({ id: 'mobile-hud-toggles', type: 'Tabs', scope: 'main' })}
      className="fixed bottom-3 left-3 z-40 flex gap-1 rounded-lg border border-border bg-card p-1 shadow-lg md:hidden"
    >
      <Button
        type="button"
        size="sm"
        variant={active === 'doctrine' ? 'default' : 'ghost'}
        aria-pressed={active === 'doctrine'}
        onClick={() => toggle('doctrine')}
        data-testid="mobile-toggle-doctrine"
        {...appDom({ id: 'mobile-toggle-doctrine', type: 'Toggle', role: 'button', scope: 'main' })}
        className="h-11 md:h-8"
      >
        <Sparkles className="size-4" />
        {t('hud.doctrine')}
      </Button>
      <Button
        type="button"
        size="sm"
        variant={active === 'map' ? 'default' : 'ghost'}
        aria-pressed={active === 'map'}
        onClick={() => toggle('map')}
        data-testid="mobile-toggle-map"
        {...appDom({ id: 'mobile-toggle-map', type: 'Toggle', role: 'button', scope: 'main' })}
        className="h-11 md:h-8"
      >
        <MapIcon className="size-4" />
        {t('hud.map')}
      </Button>
      <Button
        type="button"
        size="sm"
        variant={active === 'info' ? 'default' : 'ghost'}
        aria-pressed={active === 'info'}
        onClick={() => toggle('info')}
        data-testid="mobile-toggle-info"
        {...appDom({ id: 'mobile-toggle-info', type: 'Toggle', role: 'button', scope: 'main' })}
        className="h-11 md:h-8"
      >
        <Info className="size-4" />
        {t('hud.info')}
      </Button>
    </div>
  );
}
